import React from 'react';

const HeaderCheckbox = ({ handleSelectAllCheckboxClick, selectAll, selectedRows, files }) => {
  return <input type="checkbox" onChange={handleSelectAllCheckboxClick} checked={selectAll || selectedRows?.length === files?.length} />;
};

export default HeaderCheckbox;
